var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { "no-scroll": "", company: _vm.company } },
    [
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  _vm.createCrm = true
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: { columns: _vm.columns, items: _vm.items },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.editDossier($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-browse-pagination", {
        attrs: {
          limit: _vm.pagination.limit,
          records: _vm.count,
          page: _vm.pagination.page,
        },
        on: {
          limit: function ($event) {
            _vm.pagination.limit = $event
          },
          page: function ($event) {
            return _vm.setPage($event)
          },
        },
      }),
      _c(
        "w-modal",
        { attrs: { value: _vm.createCrm } },
        [
          _vm.createCrm
            ? _c("app-create-crm", {
                attrs: { company: _vm.company },
                on: {
                  close: function ($event) {
                    _vm.createCrm = false
                  },
                  saved: function ($event) {
                    return _vm.fetch()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }